import type { GiftCardConfig } from '#types/config/components/form/giftCard'
import type { RecursivePartial } from '#types/utils'

export default {
  showBadge: true
} satisfies RecursivePartial<GiftCardConfig>
